if (document.getElementById('vue-map')) {
	window.vueMap = new Vue({
		delimiters: ['[[', ']]'],
		el: '#vue-map',
		data: {
			open: false,
			map: null,
			countries: [],
			markers: []
		},

		mounted() {
			this.getMarkers()
		},

		computed: {},

		methods: {
			/***********************************
        GET DATA
        ***********************************/

			getMarkers() {
				Object.keys(this.$refs).forEach((key, index) => {
					this.countries.push([])
					;[...this.$refs[key].querySelectorAll('address')].forEach(
						(address) => {
							let data = address.dataset

							this.countries[index].push({
								image: data.image,
								title: data.title,
								address: data.address,
								file: data.file,
								filename: data.filename,
								coords: {
									lat: data.lat,
									lng: data.lng
								}
							})
						}
					)
				})
			},

			showMarkers(index) {
				if (this.map) {
					this.open = true

					let bounds = new google.maps.LatLngBounds()
					this.clearMarkers()

					this.markers = this.countries[index].map((marker, index) => {
						let m = new this.customMarker(marker, index)
						bounds.extend(m.getPosition())
						m.setMap(this.map)
						return m
					})

					setTimeout(() => {
						this.map.fitBounds(bounds)
						this.zoom()
					}, 500)
				}
			},

			clearMarkers() {
				this.markers.forEach((marker) => {
					marker.setMap(null)
				})
				this.markers = []
			},

			/***********************************
        MAP GESTION
        ***********************************/

			initMap() {
				this.map = new google.maps.Map(document.getElementById('map'), {
					center: { lat: 46.227638, lng: 2.213749 },
					zoom: 6,
					zoomControl: false,
					scaleControl: false,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					styles: mapStyles
				})

				this.setCustomMarkerPrototype()

				this.map.data.setStyle({
					fillColor: '#2A89C5',
					strokeColor: '#074885',
					strokeWeight: 1
				})
			},

			zoom() {
				let zoom = this.map.getZoom()
				this.map.setZoom(zoom > 8 ? 8 : zoom)
			},

			setCustomMarkerPrototype() {
				this.customMarker = function CustomMarker(marker, index) {
					this.coords = new google.maps.LatLng(
						marker.coords.lat,
						marker.coords.lng
					)
					this.index = index
					this.marker = marker
				}

				this.customMarker.prototype = new google.maps.OverlayView()

				this.customMarker.prototype.draw = function() {
					let div = this.div

					if (!div) {
						let panes = this.getPanes()

						div = this.div = document.createElement('div')
						div.className = 'marker'

						// console.log(this.marker.image)

						let file = this.marker.file
							? '<a href="' +
							  this.marker.file +
							  '" title="' +
							  this.marker.filename +
							  '" target="_blank">Lien vers pdf</a>'
							: ''

						if (this.marker.image) {
							// console.log('has image')
							div.innerHTML =
								'<div class="marker-icon"></div><div class="address-container"><div class="address"><p>' +
								this.marker.title +
								'<address>' +
								this.marker.address +
								'</address>' +
								file +
								'</div><img src="' +
								this.marker.image +
								'"/></div>'
						} else {
							div.innerHTML =
								'<div class="marker-icon"></div><div class="address-container"><div class="address"><p>' +
								this.marker.title +
								'<address>' +
								this.marker.address +
								'</address>' +
								file +
								'</div></div>'
						}

						panes.overlayImage.appendChild(div)

						google.maps.event.addDomListener(this.div, 'click', () => {
							// that.getTerritory(that.filteredData[this.index].territory);
						})
					}

					let point = this.getProjection().fromLatLngToDivPixel(this.coords)

					if (point) {
						div.style.left = point.x - 15 + 'px'
						div.style.top = point.y - 15 + 'px'
					}

					this.div = div
				}

				this.customMarker.prototype.remove = function() {
					if (this.div) {
						google.maps.event.clearInstanceListeners(this.div)
						this.div.parentNode.removeChild(this.div)
						this.div = null
					}
				}

				this.customMarker.prototype.getPosition = function() {
					return this.coords
				}

				this.customMarker.prototype.getDraggable = () => {}
			}
		}
	})
}

function initMap() {
	if (window.vueMap) {
		window.vueMap.initMap()
	}
}

let mapStyles = []
